// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'ATM terminals'" tab="true"></sub-header>
  <div class="info">
    <div class="info__column">
      <div class="info__field">
        <span class="info__field-label">Branch name:</span>
        <span class="info__field-value">{{\$ctrl.branch.name}}</span>
      </div>
      <div class="info__field">
        <span class="info__field-label">Branch code:</span>
        <span class="info__field-value">{{\$ctrl.branch.code}}</span>
      </div>
    </div>
    <div class="info__column">
      <button class="btn btn-primary"
              type="button"
              command-access="CreateAtmTerminal"
              ng-click="\$ctrl.create()">
        Add new
      </button>
    </div>
  </div>

  <table class="users-list-table table table--last-column-to-right" at-table at-list="\$ctrl.atmTerminals">
    <thead>
    <tr>
      <th at-attribute="no">No</th>
      <th at-attribute="terminalId">Terminal ID</th>
      <th at-attribute="ledgerAccountCode">GL account</th>
      <th ng-if="\$ctrl.authentication.permissions['MNG_ATM_BALANCE_READ']" at-attribute="totalCash">Balance</th>
      <th at-attribute="street">Street</th>
      <th at-attribute="barangay">Barangay</th>
      <th at-attribute="city">City</th>
      <th at-attribute="province">Province</th>
      <th at-attribute="postalCode">Postal Code</th>
      <th at-attribute="actions">Actions</th>
    </tr>
    </thead>
    <tbody class="tbody">
    <tr>
      <td at-attribute="no" class="users-list__number-column">{{\$index+1+'.'}}</td>
      <td at-implicit at-attribute="terminalId"></td>
      <td at-implicit at-attribute="ledgerAccountCode"></td>
      <td ng-if="\$ctrl.authentication.permissions['MNG_ATM_BALANCE_READ']" at-implicit at-attribute="totalCash"></td>
      <td at-implicit at-attribute="street"></td>
      <td at-implicit at-attribute="barangay"></td>
      <td at-implicit at-attribute="city"></td>
      <td at-implicit at-attribute="province"></td>
      <td at-implicit at-attribute="postalCode"></td>
      <td at-attribute="actions" class="users-list__open-link-column table__actions">
        <button class="btn btn-warning open-link"
                command-access="UpdateAtmTerminal"
                ng-click="\$ctrl.edit(item.id)">
          Edit
        </button>
      </td>
      <td class="users-list__open-link-column">
        <button type="button"
                command-access="DeleteAtmTerminal"
                class="btn btn-danger"
                ng-click="\$ctrl.delete(item.id)">
          Delete
        </button>
      </td>
    </tr>
    </tbody>
  </table>
</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/atm/list/atm-terminal-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;